/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PermissionMetadataData } from './PermissionMetadataData';
import {
    PermissionMetadataDataFromJSON,
    PermissionMetadataDataFromJSONTyped,
    PermissionMetadataDataToJSON,
    PermissionMetadataDataToJSONTyped,
} from './PermissionMetadataData';

/**
 * 
 * @export
 * @interface PermissionMetadataResponse
 */
export interface PermissionMetadataResponse {
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof PermissionMetadataResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof PermissionMetadataResponse
     */
    error?: string;
    /**
     * 
     * @type {PermissionMetadataData}
     * @memberof PermissionMetadataResponse
     */
    data?: PermissionMetadataData;
}

/**
 * Check if a given object implements the PermissionMetadataResponse interface.
 */
export function instanceOfPermissionMetadataResponse(value: object): value is PermissionMetadataResponse {
    return true;
}

export function PermissionMetadataResponseFromJSON(json: any): PermissionMetadataResponse {
    return PermissionMetadataResponseFromJSONTyped(json, false);
}

export function PermissionMetadataResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PermissionMetadataResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'data': json['data'] == null ? undefined : PermissionMetadataDataFromJSON(json['data']),
    };
}

export function PermissionMetadataResponseToJSON(json: any): PermissionMetadataResponse {
    return PermissionMetadataResponseToJSONTyped(json, false);
}

export function PermissionMetadataResponseToJSONTyped(value?: PermissionMetadataResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'error': value['error'],
        'data': PermissionMetadataDataToJSON(value['data']),
    };
}

